export const s3Config = {
    bucketName: 'afinimedia',
    dirName: 'content_manager/static/videos',   
    ACL: 'public-read',
    region: process.env.REACT_APP_S3_REGION || "",
    accessKeyId: process.env.REACT_APP_S3_ACCESS_KEY || "",
    secretAccessKey: process.env.REACT_APP_SECRET_ACCESS_KEY || "",
}